import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { includes, isEmpty, map } from 'ramda';
import { ImageUpload } from 'vms-base';
import Dropzone from 'react-dropzone';
import Tooltip from '../tooltip/Tooltip.jsx';

import s from './MapNoteSheet.module.scss';

export default class MapNotePostComment extends Component {
    static propTypes = {
        comment: PropTypes.string.isRequired,
        onCommentChange: PropTypes.func.isRequired,
        onCommentUpload: PropTypes.func.isRequired,
        onImageUpload: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.commentRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.onMouseDown, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onMouseDown, false);
    }

    onMouseDown = e => {
        if (includes('commentButton', e.target.className) && !isEmpty(this.props.comment)) {
            this.onCommentUpload();
        }
    };

    onImageUpload = async acceptedFiles => {
        const inParallel = map(ImageUpload.convertImage, acceptedFiles);
        const createdObjComments = await Promise.all(inParallel);

        this.props.onImageUpload(createdObjComments);
    };

    onCommentUpload = () => {
        this.commentRef.current.innerText = '';
        this.props.onCommentUpload(this.props.comment);
    };

    render() {
        const { comment } = this.props;
        return (
            <div className={s.postCommentWrapper}>
                <Dropzone onDrop={this.onImageUpload}>
                    {({ getRootProps, getInputProps }) => (
                        <div className={s.uploadButton} {...getRootProps()}>
                            <Tooltip arrowPosition="bottom" text="Add a PNG, JPG, or PDF up to 5 MB" />
                            <div className={classNames('icon-file', s.icon)}>
                                <input {...getInputProps()} />
                            </div>
                        </div>
                    )}
                </Dropzone>
                <div className={s.commentWrapper}>
                    <div className={s.commentTextareaWrapper}>
                        <div // Added a content-editable div capture the comment text, on input change will send the updated text to redux
                            placeholder="Post a comment..."
                            ref={this.commentRef}
                            contentEditable="true"
                            className={s.commentTextarea}
                            onInput={() => this.props.onCommentChange(this.commentRef.current.innerText)}
                        />
                        <div className={s.commentsButtonWrapper}>
                            <button type="button" onClick={this.onCommentUpload} className={s.commentButton}>
                                <div className={s.commentButtonLabel}>Post</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
